export default {
  root: ({ props }) => ({
    class: [
      // Spacing and Shape
      'mx-0',
      'rounded-md',
      'border-solid border-0 border-l-[6px]',

      // Colors
      {
        'bg-info-100/70 dark:bg-info-500/20': props.severity == 'info',
        'bg-green-100/70 dark:bg-green-500/20': props.severity == 'success',
        'bg-warning-100/70 dark:bg-warning-500/20': props.severity == 'warn',
        'bg-danger-100/70 dark:bg-danger-500/20': props.severity == 'error'
      },
      {
        'border-info-500 dark:border-info-400': props.severity == 'info',
        'border-green-500 dark:border-green-400': props.severity == 'success',
        'border-warning-500 dark:border-warning-400': props.severity == 'warn',
        'border-danger-500 dark:border-danger-400': props.severity == 'error'
      },
      {
        'text-info-700 dark:text-info-300': props.severity == 'info',
        'text-green-700 dark:text-green-300': props.severity == 'success',
        'text-warning-700 dark:text-warning-300': props.severity == 'warn',
        'text-danger-700 dark:text-danger-300': props.severity == 'error'
      }
    ]
  }),
  wrapper: {
    class: [
      // Flexbox
      'flex items-center',

      // Spacing
      'p-3'
    ]
  },
  icon: {
    class: [
      // Sizing and Spacing
      'w-6 h-6',
      'text-lg leading-none mr-2 shrink-0'
    ]
  },
  text: {
    class: [
      // Font and Text
      'text-base leading-none',
      'font-medium'
    ]
  },
  button: {
    class: [
      // Flexbox
      'flex items-center justify-center',

      // Size
      'w-8 h-8',

      // Spacing and Misc
      'ml-auto  relative',

      // Shape
      'rounded-full',

      // Colors
      'bg-transparent',

      // Transitions
      'transition duration-200 ease-in-out',

      // States
      'hover:bg-secondary-0/50 dark:hover:bg-secondary-0/10',

      // Misc
      'overflow-hidden'
    ]
  },
  transition: {
    enterFromClass: 'opacity-0',
    enterActiveClass: 'transition-opacity duration-300',
    leaveFromClass: 'max-h-40',
    leaveActiveClass: 'overflow-hidden transition-all duration-300 ease-in',
    leaveToClass: 'max-h-0 opacity-0 !m-0'
  }
};
